import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { InviteUserPayload, InviteUserResult, User, UserModule, UserRole } from './user.models';

@Injectable({ providedIn: 'root' })
export class UserService {
  private readonly http = inject(HttpClient);
  private readonly auth = inject(AuthService);

  private base(): string {
    return `/api/t/${this.auth.currentTenant()}/usuarios`;
  }

  list(): Observable<User[]> {
    return this.http.get<User[]>(this.base());
  }

  /** Quem está ativo na equipa — para escolher responsáveis; não exige a gestão de acessos. */
  team(): Observable<User[]> {
    return this.http.get<User[]>(`${this.base()}/equipa`);
  }

  invite(payload: InviteUserPayload): Observable<InviteUserResult> {
    return this.http.post<InviteUserResult>(this.base(), payload);
  }

  resendInvite(id: number): Observable<InviteUserResult> {
    return this.http.post<InviteUserResult>(`${this.base()}/${id}/reenviar-convite`, {});
  }

  /** Matriz de módulos do utilizador — devolve sempre todos, mesmo os sem acesso. */
  modules(id: number): Observable<UserModule[]> {
    return this.http.get<UserModule[]>(`${this.base()}/${id}/modulos`);
  }

  setModules(id: number, modules: UserModule[]): Observable<UserModule[]> {
    return this.http.put<UserModule[]>(`${this.base()}/${id}/modulos`, { modules });
  }

  updateRole(id: number, role: UserRole): Observable<User> {
    return this.http.put<User>(`${this.base()}/${id}/papel`, { role });
  }

  setStatus(id: number, active: boolean): Observable<User> {
    return this.http.put<User>(`${this.base()}/${id}/status`, { active });
  }
}
